import React from 'react';
import './DesktopIcon.css';

const DesktopIcon = ({ icon, iconSrc, label, onClick }) => {
  return (
    <div className="desktop-icon" onClick={onClick}>
      <div className="icon-image">
        {iconSrc ? (
          <img src={iconSrc} alt={label} className="icon-img" />
        ) : (
          icon
        )}
      </div>
      <div className="icon-label">
        {label}
      </div>
    </div>
  );
};

export default DesktopIcon;